// tslint:disable: max-line-length
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CoreModule } from 'app/core/core.module';
import { CustomMaterialModule } from 'app/custom-material/custom-material.module';
import { GuidedTourModule } from 'ngx-guided-tour';
import { CreatePlanDocumentComponent } from './components/create-plan-document/create-plan-document.component';
import { AddEditPhaseDialogComponent } from './components/document-planning/document-calendar/add-edit-phase-dialog/add-edit-phase-dialog.component';
import { AddRestrictionDialogComponent } from './components/document-planning/document-calendar/add-restriction-dialog/add-restriction-dialog.component';
import { DocumentCalendarComponent } from './components/document-planning/document-calendar/document-calendar.component';
import { DocumentDayPlanningComponent } from './components/document-planning/document-day-planning/document-day-planning.component';
import { DocumentTierPlanningComponent } from './components/document-planning/document-day-planning/document-tier-planning/document-tier-planning.component';
import { DocumentTierRowNotesDialogComponent } from './components/document-planning/document-day-planning/document-tier-planning/document-tier-row-notes-dialog/document-tier-row-notes-dialog.component';
import { DocumentTierStairsComponent } from './components/document-planning/document-day-planning/document-tier-stairs/document-tier-stairs.component';
import { DocumentPlanDayActionsComponent } from './components/document-planning/document-plan-day-actions/document-plan-day-actions.component';
import { DocumentPlanDaySummaryComponent } from './components/document-planning/document-plan-day-summary/document-plan-day-summary.component';
import { DocumentPlanSummaryComponent } from './components/document-planning/document-plan-summary/document-plan-summary.component';
import { DocumentPlanTitleBarComponent } from './components/document-planning/document-plan-title-bar/document-plan-title-bar.component';
import { DocumentPlanningComponent } from './components/document-planning/document-planning.component';
import { DocumentAddWorkoutDialogComponent } from './components/document-planning/document-workout-selector/document-add-workout-dialog/document-add-workout-dialog.component';
import { DocumentWorkoutSelectorComponent } from './components/document-planning/document-workout-selector/document-workout-selector.component';
import { PlanDocumentListItemComponent } from './components/plan-document-list-item/plan-document-list-item.component';
import { TrainingLoadNoticeDialogComponent } from './components/training-load-notice-dialog/training-load-notice-dialog.component';
import { DocumentRoutingModule } from './document-routing.module';
// tslint:enable: max-line-length

@NgModule({
  imports: [
    CommonModule,
    CustomMaterialModule,
    BrowserModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    DocumentRoutingModule,
    CoreModule,
    DragDropModule,
    GuidedTourModule,
  ],
  declarations: [
    PlanDocumentListItemComponent,
    CreatePlanDocumentComponent,
    DocumentPlanningComponent,
    DocumentCalendarComponent,
    AddRestrictionDialogComponent,
    AddEditPhaseDialogComponent,
    DocumentPlanSummaryComponent,
    DocumentPlanTitleBarComponent,
    DocumentPlanDayActionsComponent,
    DocumentPlanDaySummaryComponent,
    DocumentDayPlanningComponent,
    DocumentTierStairsComponent,
    DocumentTierPlanningComponent,
    DocumentTierRowNotesDialogComponent,
    TrainingLoadNoticeDialogComponent,
    DocumentWorkoutSelectorComponent,
    DocumentAddWorkoutDialogComponent
  ],
  providers: [TitleCasePipe],
  exports: [PlanDocumentListItemComponent]
})
export class DocumentModule {}
